export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-12.png?48c28ba0639af172a698e5a22005ae81";